import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export interface TcPaginationProps {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
  itemLabel?: string;
  onPageSizeChange?: (pageSize: number) => void;
  pageSizeOptions?: number[];
}

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const TcPagination: React.FC<TcPaginationProps> = ({
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
  disabled = false,
  itemLabel = 'registros',
  onPageSizeChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}) => {
  if (total === 0) return null;
  if (totalPages <= 1 && !onPageSizeChange) return null;

  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <Box
      component="nav"
      aria-label="Paginação"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 2,
        py: 1.5,
      }}
    >
      {onPageSizeChange && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Itens por página
          </Typography>
          <FormControl size="small" variant="filled" disabled={disabled}>
            <Select
              value={pageSize}
              onChange={(event) => {
                const size = Number(event.target.value);
                if (size !== pageSize) onPageSizeChange(size);
              }}
              sx={{ minWidth: 80 }}
            >
              {pageSizeOptions.map((opt) => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}

      <Button
        variant="outlined"
        size="small"
        disabled={disabled || page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        Anterior
      </Button>

      <Typography variant="body2" color="text.secondary" sx={{ flex: '1 1 auto', minWidth: 0 }}>
        {from}–{to} de {total} {itemLabel} · página {page} de {totalPages}
      </Typography>

      <Button
        variant="outlined"
        size="small"
        disabled={disabled || page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Próxima
      </Button>
    </Box>
  );
};

export default TcPagination;
